<template>
    <b-form @submit.prevent="validateFormGeneral()"
            data-vv-scope="tasks"
    >
        <b-row>
            <b-col cols="12">
                <b-form-group>
                    <label for="slq_location_id">
                        Ubicación
                    </label>
                    <tree-select id="slq_location_id"
                                 name="slq_location_id"
                                 data-vv-as=" "
                                 :value="task.slq_location_id"
                                 :multiple="false"
                                 :defaultExpandLevel="Infinity"
                                 :options="locations"
                                 value-consists-of="ALL_WITH_INDETERMINATE"
                                 @input="setSlqLocationIdToTask"
                                 v-validate="'required'"
                    />
                    <div class="text-danger small"
                         v-text="errors.first('tasks.slq_location_id')"
                    />
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group>
                    <label for="name">Nombre</label>
                    <el-input id="name"
                              name="name"
                              size="small"
                              v-model="task.name"
                              data-vv-as=" "
                              v-validate="'required|min:3|max:255'"
                              maxlength="255"
                              show-word-limit
                    />
                    <div class="text-danger small"
                         v-text="errors.first('tasks.name')"
                    />

                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group>
                    <label for="positions">
                        Cargos
                    </label>
                    <el-select v-model="task.positions"
                               id="positions"
                               name="positions"
                               filterable
                               size="small"
                               placeholder="Seleccione un Cargo"
                               class="w-100"
                               no-data-text="No hay datos que coincidan"
                               no-match-text="No hay datos que coincidan"
                               data-vv-as=" "
                               v-validate="'required'"
                               multiple
                    >
                        <el-option v-for="position in positions"
                                   :key="position.id"
                                   :label="position.name"
                                   :value="position.id"
                        />
                    </el-select>
                    <div class="text-danger small"
                         v-text="errors.first('tasks.positions')"
                    />
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group>
                    <label for="description">Descripción</label>
                    <el-input id="description"
                              name="description"
                              type="textarea"
                              size="small"
                              v-model="task.description"
                              data-vv-as=" "
                              v-validate="'required|min:3|max:1000'"
                              maxlength="1000"
                              show-word-limit
                    />
                    <div class="text-danger small"
                         v-text="errors.first('tasks.description')"
                    />
                </b-form-group>
            </b-col>

            <b-col cols="12"
                   v-if="!task.url"
            >
                <b-form-file id="image"
                             name="image"
                             v-model="task.image"
                             data-vv-as=" "
                             v-validate="'mimes:image/jpeg,image/png,image/jpg'"
                             accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                             data-vv-delay="1000"
                             placeholder="Elija un archivo o suéltelo aquí..."
                             drop-placeholder="Suelta el archivo aquí..."
                             @change="onFileChange"
                />
                <span class="text-danger small"
                      v-text="imageTypeError || errors.first('tasks.image')"
                />
            </b-col>

            <b-col cols="12" class="text-center">
                <template v-if="task.url">
                    <b-img :src="task.url"
                            thumbnail
                            rounded
                            fluid
                            alt="task"
                            style="max-height: 200px; max-width: 200px"
                    />

                    <br>

                    <el-tooltip popper-class="py-1 px-2"
                                effect="dark"
                                placement="bottom"
                                content="Eliminar imagen"
                    >
                        <b-btn variant="danger"
                            class="m-1"
                            size="sm"
                            @click="setUrlToTask(null)"
                        >
                            <i class="fa fa-trash"/> Eliminar
                        </b-btn>
                    </el-tooltip>
                </template>
                <template v-else-if="task.id">
                    <div class="text-muted text-center no-image">
                        Sin imagen
                    </div>
                </template>                
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <hr/>

                <b-btn variant="primary"
                       class="float-right"
                       size="sm"
                       @click="validateFormGeneral()"
                       :disabled="!isFormValid"
                >
                    Siguiente
                    <i class="fa fa-arrow-right"/>
                </b-btn>
                <b-btn variant="secondary"
                       class="float-left"
                       size="sm"
                       @click="setModalShow(false)"
                >
                    <i class="fa fa-close"/> Cancelar
                </b-btn>
            </b-col>
        </b-row>
    </b-form>
</template>


<script>
import {mapMutations, mapState} from 'vuex';
import TreeSelect from '@riophae/vue-treeselect';

export default {
    name: 'task',
    components: {TreeSelect},
    computed: {
        ...mapState('tasks', [
            'task',
            'modal',
            'positions',
            'locations'
        ]),
        isFormValid() {
            // Verifica que los campos requeridos estén completos y sin errores
            const nameValid = this.task.name && this.task.name.length >= 3 && this.task.name.length <= 255 && !this.errors.first('tasks.name');
            const descValid = this.task.description && this.task.description.length >= 3 && this.task.description.length <= 1000 && !this.errors.first('tasks.description');
            const locValid = !!this.task.slq_location_id && !this.errors.first('tasks.slq_location_id');
            const posValid = Array.isArray(this.task.positions) && this.task.positions.length > 0 && !this.errors.first('tasks.positions');
            return nameValid && descValid && locValid && posValid;
        }
    },
    data() {    
        return {
            imageTypeError: ''
        };
    },
    methods: {
        ...mapMutations('tasks', [
            'setModalShow',
            'increaseStepToModal',
            'setUrlToTask',
            'setSlqLocationIdToTask'
        ]),
        validateFormGeneral() {
            this.$validator.validateAll('tasks')
                .then((result) => {
                    if (result) {
                        this.increaseStepToModal();
                    }
                    if (this.$validator && this.$validator.reset) {
                        this.$validator.reset();
                    }
                });
        },
        onFileChange(e) {
            const file = e.target.files[0];
            this.imageTypeError = '';
            this.task.image = null;

            if (!file) return;      
            
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            const maxSize = 20 * 1024 * 1024; // 20MB
                          
            if (!validTypes.includes(file.type)) {
                this.imageTypeError = 'Solo se permiten imágenes PNG o JPG.';
           } else if (file.size > maxSize) {
                this.imageTypeError = 'El tamaño máximo permitido es 20MB.';
            } else {
                this.task.image = file;
                const reader = new FileReader();
                reader.readAsDataURL(file);
                    reader.onload = e => {
                    this.setUrlToTask(e.target.result);
                };
                return;
            }
            e.target.value = '';
        }
    }
};
</script>

<style
    src="../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"
></style>
<style scoped>

.no-image {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 24px 0;
    font-size: 16px;
}

</style>